module.exports = __webpack_public_path__ + "media/images/emblems/Massagno-coat_of_arms-6077ff7004da0e86c8e1c32ada98f804.svg";